


















































import { IJuheGameItem } from "@/api/modules/basic"
import { DateFotmat } from "@/utils/base"
import { Component, Prop, Vue, Watch } from "vue-property-decorator"

@Component({
  name: "GameItem",
  components: {
    Item: () => import("../Item/Item.vue")
  }
})
export default class GameItem extends Vue {
  @Prop({})
  propData: IJuheGameItem

  DateFotmat = DateFotmat
}
